<template>
  <div>
    <TabbarComponent></TabbarComponent>
    <NotificationUnread @updateUnreadCount="updateUnreadCount"></NotificationUnread>
    <tabs v-model="activeTab" @change="onChangeTab" color="#fc9153" title-active-color="#fc9153" swipeable sticky line-width="15px" :border="false"
          class="tab-list-container">
      <tab v-for="tabItem in tabList" :key="tabItem.route" :name="tabItem.route" :dot="tabItem.id === 2?dotNotification:false">
        <div slot="title">
          <div :class="['title-slot',activeTab===tabItem.route?'active-title-slot':'']">
            <span>{{tabItem.name}}</span>
          </div>
        </div>
      </tab>
      <router-view></router-view>
    </tabs>
  </div>
</template>

<script>
  import {Tabs, Tab} from "vant"
  import NotificationUnread from "../common/NotificationUnread";
  import TabbarComponent from "../common/TabbarComponent";
  export default {
    name: "MomentTabHeader",
    components: {
      TabbarComponent,
      NotificationUnread,
      Tabs, Tab
    },
    data() {
      return {
        activeTab: "",
        tabList: [
          {"id": 1, "name": "最新", "icon_name": "", "route": "/_tab_moment/moment"},
          {"id": 2, "name": "消息", "icon_name": "", "route": "/_tab_moment/notification"},
        ],
        dotNotification: false,
      }
    },
    mounted() {
      this.switchTabActive(this.$route.path)
    },
    activated() {
      this.switchTabActive(this.$route.path)
    },
    methods: {
      updateUnreadCount(msg) {
        if (msg) {
          this.dotNotification = true
        } else {
          this.dotNotification = false
        }
        console.log("dot", this.dotNotification)
      },
      onChangeTab(name) {
        this.$router.push({path: name})
      },

      switchTabActive(fullPath) {
        console.log(fullPath)
        for (let i = 0; i < this.tabList.length; i++) {
          let tabItem = this.tabList[i]
          if (tabItem.route === fullPath) {
            this.activeTab = tabItem.route
          }
        }
      },
    },
  }
</script>


<style lang="scss" scoped>
  .body {
  }

  .tab-list-container {

    .title-slot {
      line-height: 1.5;
    }

    .active-title-slot {
      font-size: 18px;
      span {
        font-weight: bold;
      }
    }
  }
  .top-empty {
    z-index: 1000;
    width: 100%;
    height: 1px;
    position: fixed;
    top: 0;
    left: 0;
    background: white;
  }
</style>
